import { memo, useMemo } from 'react';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { authApiBase } from 'root/src/shared/constants/auth';
import { SocialPlatform } from 'root/src/server/util/awsClients/authApiClient.types';
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
import { getReadableSocialPlatform } from 'root/src/shared/platforms/helpers/getReadablePlatform';
import { FaSteam } from 'react-icons/fa';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
const ICON_MAP = {
    [SocialPlatform.Steam]: FaSteam,
};
export const SignInWithSocialAccount = memo(({ socialPlatform }) => {
    var _a;
    const socialAccountsQuery = trpc.auth.socialAccounts.useQuery();
    const state = useMemo(() => {
        return encodeURIComponent(JSON.stringify({
            redirectURL: window.location.href,
            token: getCookie('accessToken'),
        }));
    }, []);
    const socialAccounts = (socialAccountsQuery === null || socialAccountsQuery === void 0 ? void 0 : socialAccountsQuery.data) || [];
    if (!socialAccounts.length) {
        return null;
    }
    const account = socialAccounts.find(a => a.platform === socialPlatform);
    const Icon = ICON_MAP[socialPlatform];
    return (<ModalLayout>
			<div className="flex flex-col gap-4">
				<p className="text-lg font-bold text-center">
					Connect {getReadableSocialPlatform(socialPlatform)} account
				</p>
				<ButtonNew disabled={!!account || socialAccountsQuery.isLoading} className="w-full h-[37.5px] rounded items-center flex justify-center bg-dark-google border-[0.5px] hover:border-dark-googleBorder hover:bg-dark-google border-dark-googleBorder" asChild>
					<a className="text-sm" rel="noreferrer" href={account ? '#' : `${authApiBase}/sign-in/${socialPlatform}?state=${state}`}>
						<Icon className="text-xl mr-2"/> {account ? <>{(_a = account.displayName) !== null && _a !== void 0 ? _a : account.platformId}</> : <>Sign in with {getReadableSocialPlatform(socialPlatform)}</>}
					</a>
				</ButtonNew>
			</div>
		</ModalLayout>);
});
